'use client';
import { getColorScheme } from '@/utils/getColorScheme';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';

export default function CustomCode(props) {
    const {
        Anchor,
        Code,
        is_edit_mode,
        ColorScheme = 'white',
        VerticalSpacing = '',
    } = props;

    const { backgroundColor, textColor, backgroundStyle } = getColorScheme(
        ColorScheme,
        props.GradientDirection
    );

    let vSpace, containerClass;

    const vspaceKey = String(VerticalSpacing || '').trim();
    const isFullBleed =
        !vspaceKey || vspaceKey === 'default' || vspaceKey === 'full';

    if (vspaceKey === 'larger') {
        vSpace = 'min-h-[900px] lg:min-h-[1200px] xl:min-h-[30vw]';
        containerClass = 'h-full w-full';
    } else if (isFullBleed) {
        vSpace = '';
        containerClass = 'h-full w-full';
    } else {
        vSpace = getVerticalSpacing(vspaceKey);
        containerClass = 'max-w-7xl px-6 lg:px-8';
    }

    return (
        <div
            id={Anchor}
            className={`relative mx-auto w-full ${backgroundColor} ${textColor}`}
            style={backgroundStyle}
        >
            <div
                className={`relative z-[45] mx-auto flex flex-col ${containerClass} ${vSpace}`}
                style={{ minHeight: '100%' }}
            >
                <div className="relative">
                    {/* Editor overlay message */}
                    {is_edit_mode && (
                        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center border-2 border-dashed border-primary-600 bg-white/50">
                            <span className="text-center text-xl text-black">
                                Editor Mode - Enter your custom code in the
                                editor panel.
                            </span>
                        </div>
                    )}

                    {/* Code block - make sure it takes up height */}
                    <div
                        className={`relative ${
                            is_edit_mode ? 'min-h-[300px]' : ''
                        }`}
                        dangerouslySetInnerHTML={{ __html: Code || '' }}
                    />
                </div>
            </div>
        </div>
    );
}
